import { createSelector } from '@ngrx/store';
import { State } from '../../reducers';
import * as fromProducts from './products.reducer';


export const products = (state: State) => state.products;

export const selectProducts = createSelector(products, (state: fromProducts.State) => state.products);
